<template>

    <div class="search-results-container">

        <div class="banner" style="margin-bottom: 30px;">
            <img src="/imgs/banner.jpg" style="width: 100%;height: 400px;">
        </div>

        <!-- 加载状态 -->
        <div v-if="loading" class="loading-container">
            <i class="el-icon-loading" style="font-size: 48px; color: #409EFF;"></i>
            <p>正在加载文章数据...</p>
        </div>

        <!-- 搜索结果列表 -->
        <div v-else>
            <div v-if="filteredArticles.length > 0" class="articles-list">
                <div v-for="article in filteredArticles" :key="article.id" class="article-card"
                    @click="viewArticle(article.id)">
                    <div class="article-image">
                        <img :src="article.img" alt="文章图片" v-if="article.img">
                        <div v-else class="image-placeholder">
                            <i class="el-icon-picture"></i>
                        </div>
                    </div>
                    <div class="article-info">
                        <h3 class="article-title">{{ article.title }}</h3>
                        <div class="article-meta">
                            <span><i class="el-icon-user"></i> {{ article.author }}</span>
                            <span><i class="el-icon-time"></i> {{ article.time }}</span>
                            <span><i class="el-icon-view"></i> {{ article.sub }} 阅读</span>
                        </div>
                        <p class="article-abstract">{{ article.jj ? article.jj.slice(0, 120) + '...' : '暂无简介' }}</p>
                        <div class="article-price" v-if="article.pay">
                            <span>{{ article.pay }}</span>
                        </div>
                    </div>
                </div>
            </div>

            <!-- 未找到结果 -->
            <div v-else class="no-results">
                <i class="el-icon-search" style="font-size: 48px; color: #999;"></i>
                <h3>没有找到相关内容</h3>
                <p>请尝试使用其他关键词搜索</p>
                <el-button type="primary" @click="goBack" class="back-button">返回首页</el-button>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'SearchResults',
    data() {
        return {
            searchKeyword: '',
            articles: [],
            loading: true,
        };
    },
    computed: {
        // 根据关键词过滤文章
        filteredArticles() {
            if (!this.searchKeyword) return [];

            const keyword = this.searchKeyword.toLowerCase();
            return this.articles.filter(article => {
                return article.title.toLowerCase().includes(keyword) ||
                    (article.jj && article.jj.toLowerCase().includes(keyword)) ||
                    (article.author && article.author.toLowerCase().includes(keyword));
            });
        }
    },
    created() {
        // 加载文章数据
        this.loadArticles();

        // 初始化时从路由参数获取关键词
        this.searchKeyword = this.$route.query.keyword || '';
    },
    watch: {
        // 监听路由参数变化（当在搜索页内再次搜索时触发）
        '$route.query.keyword'(newKeyword) {
            this.searchKeyword = newKeyword || '';
            this.doSearch();
        }
    },
    methods: {
        // 加载JSON数据
        async loadArticles() {
            this.loading = true;
            try {
                const response = await fetch('/mock/ac.json');
                if (!response.ok) {
                    throw new Error('无法加载文章数据');
                }
                this.articles = await response.json();
            } catch (error) {
                console.error('加载文章数据失败:', error);
                this.$message.error('加载文章数据失败，请稍后再试');
            } finally {
                this.loading = false;
            }
        },

        // 执行搜索
        doSearch() {
            if (!this.searchKeyword.trim()) {
                this.$message.warning('请输入搜索关键词');
                return;
            }

            // 当搜索页内部搜索时，避免重复执行相同搜索
            if (this.$route.query.keyword === this.searchKeyword) {
                return;
            }
        },

        // 查看文章详情
        viewArticle(id) {
            this.$router.push(`/article/${id}`);
        },

        // 返回首页
        goBack() {
            this.$router.push('/');
        }
    }
};
</script>

<style lang="scss" scoped>
.search-results-container {
    max-width: 1200px;
    margin: 20px auto;
    padding: 0 20px;

    .search-header {
        text-align: center;
        margin-bottom: 30px;

        .search-input {
            max-width: 600px;
            margin: 0 auto 20px;

            ::v-deep .el-input__inner {
                height: 46px;
                font-size: 16px;
            }

            ::v-deep .el-input-group__append {
                background-color: #409EFF;
                color: white;
                font-size: 18px;
                padding: 0 25px;
            }
        }

        .result-count {
            color: #666;
            font-size: 14px;
        }
    }

    .loading-container {
        text-align: center;
        padding: 50px;
        background: #fff;
        border-radius: 8px;
        box-shadow: 0 2px 12px rgba(0, 0, 0, 0.05);

        p {
            margin-top: 15px;
            color: #606266;
        }
    }

    .articles-list {
        display: grid;
        grid-template-columns: repeat(auto-fill, minmax(350px, 1fr));
        gap: 25px;
    }

    .article-card {
        display: flex;
        flex-direction: column;
        border-radius: 8px;
        overflow: hidden;
        box-shadow: 0 3px 10px rgba(0, 0, 0, 0.08);
        transition: all 0.3s ease;
        cursor: pointer;
        background: #fff;

        &:hover {
            transform: translateY(-5px);
            box-shadow: 0 5px 15px rgba(0, 0, 0, 0.12);

            .article-title {
                color: #409EFF;
            }
        }

        .article-image {
            height: 180px;
            overflow: hidden;

            img {
                width: 100%;
                height: 100%;
                object-fit: cover;
                transition: transform 0.5s ease;
            }

            &:hover img {
                transform: scale(1.05);
            }

            .image-placeholder {
                height: 100%;
                background: #f5f7fa;
                display: flex;
                align-items: center;
                justify-content: center;
                color: #909399;
                font-size: 50px;
            }
        }

        .article-info {
            padding: 20px;

            .article-title {
                font-size: 18px;
                font-weight: 600;
                margin-bottom: 12px;
                transition: color 0.3s;
                line-height: 1.4;
                display: -webkit-box;
                -webkit-line-clamp: 2;
                -webkit-box-orient: vertical;
                overflow: hidden;
            }

            .article-meta {
                display: flex;
                flex-wrap: wrap;
                gap: 15px;
                margin-bottom: 15px;
                font-size: 13px;
                color: #909399;

                span {
                    display: flex;
                    align-items: center;

                    i {
                        margin-right: 5px;
                        font-size: 14px;
                    }
                }
            }

            .article-abstract {
                color: #606266;
                font-size: 14px;
                line-height: 1.6;
                margin-bottom: 15px;
                display: -webkit-box;
                -webkit-line-clamp: 3;
                -webkit-box-orient: vertical;
                overflow: hidden;
            }

            .article-price {
                padding-top: 15px;
                border-top: 1px dashed #e6e6e6;
                color: #E6A23C;
                font-weight: 500;
                font-size: 15px;
            }
        }
    }

    .no-results {
        text-align: center;
        padding: 50px 20px;
        background: #fff;
        border-radius: 8px;
        box-shadow: 0 2px 12px rgba(0, 0, 0, 0.05);

        h3 {
            font-size: 22px;
            color: #333;
            margin: 20px 0 10px;
        }

        p {
            color: #666;
            margin-bottom: 25px;
        }

        .back-button {
            padding: 10px 30px;
        }
    }
}
</style>